import React, { useState } from "react";
import "./style.sass";
import assets from "../../../assets";
import { useNavigate } from "react-router-dom";
import { ROUTE_DASHBOARD } from "../../../route/communicative";
import { LatexRenderer } from "../../../components/latex-renderer";

const ScoreIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="10" stroke="#16A34A" strokeWidth="2" />
    <path
      d="M8 12.5l2.5 2.5L16 9"
      stroke="#16A34A"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const CorrectIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <path
      d="M12 3l2.6 2.2 3.4-.4.7 3.4 3 1.8-1.6 3.1L21 16l-3 1.8-.7 3.4-3.4-.4L12 23l-2.6-2.2-3.4.4-.7-3.4-3-1.8 1.6-3.1L3 10l3-1.8.7-3.4 3.4.4z"
      stroke="#7C3AED"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
    <circle cx="12" cy="12" r="2.5" stroke="#7C3AED" strokeWidth="1.6" />
  </svg>
);

const QuestionsIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="10" stroke="#2563EB" strokeWidth="2" />
    <path
      d="M9.5 9a2.5 2.5 0 114.2 1.8c-.6.6-1.7 1-1.7 2.2"
      stroke="#2563EB"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <circle cx="12" cy="16.5" r="0.9" fill="#2563EB" />
  </svg>
);

const SparkleIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
    <path
      d="M12 2l1.8 5.2L19 9l-5.2 1.8L12 16l-1.8-5.2L5 9l5.2-1.8z"
      fill="#7C3AED"
    />
  </svg>
);

function TextQuestion({ index, question }) {
  return (
    <section className="question-card">
      <p className="question-card__prompt">
        {index}. <LatexRenderer text={question.prompt} inline />
      </p>

      <textarea
        className="question-card__textarea"
        value={question.student_answer}
        disabled
      />

      <p>
        <strong>Correct Answer:</strong> <LatexRenderer text={question.correct_answer} inline />
      </p>

      <p><LatexRenderer text={question.explanation} /></p>
    </section>
  );
}
function McqQuestion({ index, question }) {
  return (
    <section className="question-card">
      <p className="question-card__prompt">
        {index}. <LatexRenderer className="correct_ans_font" text={question.prompt} inline />
      </p>

      <section className="question-card__options">
        {question.options.map((option) => {
          const isSelected = option === question.student_answer;
          const isCorrect = option === question.correct_answer;

          let classes = ["option"];

          if (isCorrect) {
            classes.push("option--correct");
          }

          if (isSelected && !isCorrect) {
            classes.push("option--incorrect");
          }

          return (
            <section key={option} className={classes.join(" ")}>
              <LatexRenderer className="options_font" text={option} inline />
            </section>
          );
        })}
      </section>

      <section className="question-feedback">
        <p>
          <strong>Correct Answer:</strong> <LatexRenderer className="correct_ans_font" text={question.correct_answer} inline />
        </p>

        <p><LatexRenderer className="correct_ans_font" text={question.explanation} /></p>
      </section>
    </section>
  );
}

export const ResultsReview = ({ resultData }) => {
  const navigate = useNavigate();
  const questions = resultData?.questions || [];
  const feedback = resultData?.feedback || [];

  const score = resultData?.score || 0;
  const correct = resultData?.correct || 0;
  const totalQuestions = resultData?.total || 0;
  const studentName = resultData?.user_name || "";

  const reviewQuestions = questions.map((question) => {
    const review = feedback.find((item) => item.id === question.id);

    return {
      ...question,
      ...review,
    };
  });

  return (
    <section className="results-review">
      <header className="grammar-setup__header">
        <section className="grammar-setup__brand">
          <img src={assets.ic_logo} alt="logo" />
          <span className="grammar-setup__brand-name">Rovian AI</span>
        </section>
        <h6
          className="grammar-setup__dashboard-link"
          onClick={() => navigate(ROUTE_DASHBOARD)}
        >
          <span aria-hidden="true">←</span> Dashboard
        </h6>
      </header>

      <main className="results-review__content">
        <h1 className="results-review__title">Grammar</h1>
        <p className="results-review__subtitle">
          Review your grammar quiz results and track your progress..
        </p>

        <section className="summary-card">
          <section className="summary-card__heading">
            <SparkleIcon />
            <span>Results</span>
          </section>
          <h2 className="summary-card__title">
            Excellent work, {studentName}!
          </h2>
          <p className="summary-card__description">
            You completed the reading practice successfully. Keep reading
            regularly to improve your comprehension, vocabulary, and confidence.
          </p>

          <section className="summary-card__stats">
            <section className="stat-card stat-card--green">
              <section className="stat-card__icon">
                <ScoreIcon />
              </section>
              <p className="stat-card__label">SCORE</p>
              <p className="stat-card__value">{score}%</p>
            </section>

            <section className="stat-card stat-card--purple">
              <section className="stat-card__icon">
                <CorrectIcon />
              </section>
              <p className="stat-card__label">CORRECT</p>
              <p className="stat-card__value">{correct}</p>
            </section>

            <section className="stat-card stat-card--blue">
              <section className="stat-card__icon">
                <QuestionsIcon />
              </section>
              <p className="stat-card__label">TOTOAL QUESTIONS</p>
              <p className="stat-card__value">{totalQuestions}</p>
            </section>
          </section>
        </section>

        <section className="questions-list">
          {/* {questions.map((q, i) =>
            q.type === "text" ? (
              <TextQuestion key={q.id} index={i + 1} question={q} />
            ) : (
              <McqQuestion key={q.id} index={i + 1} question={q} />
            ),
          )} */}
          {reviewQuestions.map((q, i) => {
            if (q.type === "multiple_choice") {
              return <McqQuestion key={q.id} index={i + 1} question={q} />;
            }

            return <TextQuestion key={q.id} index={i + 1} question={q} />;
          })}
        </section>
      </main>
    </section>
  );
};
